import apiClient from "../utils/axios.utils";

const API_BASE = "/donors";

export const DonationService = {
    async createDonation(donationData: {
        firstName: string;
        lastName: string;
        email: string;
        address: string;
        postalCode: string;
        city: string;
        amount: number;
        phoneNumber?: string;
        description?: string;
    }): Promise<{ success: boolean; message: string }> {
        const res = await apiClient.post(`${API_BASE}/public`, donationData);
        return { success: true, message: "Don enregistré avec succès" };
    }
};